// src/components/PostAd/LocationPicker.js
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { usePostAd } from '../../contexts/PostAdContext';
import { formatLocationForFirestore } from '../../utils/geoUtils';
import { FiSearch, FiArrowRight, FiMapPin } from 'react-icons/fi';
import './LocationPicker.css';

const LocationPicker = () => {
  const { setLocation, setStep } = usePostAd();
  const [selectedDisplay, setSelectedDisplay] = useState('');
  const autocompleteHost = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

  const handleSelect = useCallback(async (event) => {
    console.log("EVENT:", event);

    const prediction = event.placePrediction;

    if (!prediction) {
      console.warn("No placePrediction found");
      return;
    }

    const place = prediction.toPlace();

    if (!place) {
      console.warn("No place object found in selection event");
      return;
    }

    try {
      await place.fetchFields({
        fields: ['addressComponents', 'formattedAddress', 'location', 'displayName']
      });

      if (!place.location) return;

      const address = { city: '', state: '', neighbourhood: '', village: '', pincode: '' };

      place.addressComponents?.forEach(c => {
        if (c.types.includes('locality')) address.city = c.longText;
        if (c.types.includes('administrative_area_level_1')) address.state = c.longText;
        if (c.types.includes('sublocality_level_1')) address.village = c.longText;
        if (c.types.includes('sublocality_level_2')) address.neighbourhood = c.longText;
        if (c.types.includes('postal_code')) address.pincode = c.longText;
      });

      if (!address.village && address.neighbourhood) {
        address.village = address.neighbourhood;
      }

      const finalLocation = formatLocationForFirestore(
        address,
        place.location.lat(),
        place.location.lng()
      );

      finalLocation.display = place.formattedAddress || place.displayName;

      setLocation(finalLocation);
      setSelectedDisplay(finalLocation.display);

      console.log("✅ Location set:", finalLocation.display);

    } catch (error) {
      console.error('Post Ad Location Error:', error);
    }
  }, [setLocation]);

  useEffect(() => {
    const setup = async () => {
      if (!window.google?.maps?.importLibrary || !autocompleteHost.current) return;

      const { PlaceAutocompleteElement } = await window.google.maps.importLibrary('places');

      if (!isMountedRef.current) return;

      const picker = new PlaceAutocompleteElement();
      picker.id = "qinto-post-ad-input";

      try {
        picker.componentRestrictions = { country: ['IN'] };
      } catch (e) { console.error(e); }

      autocompleteHost.current.innerHTML = '';
      autocompleteHost.current.appendChild(picker);

      // Listen for selection
      picker.addEventListener('gmp-select', handleSelect);
    };

    setup();
  }, [handleSelect]);

  return (
    <div className="location-picker-container">
      <h2>Confirm Location</h2>
      <p>Where are you selling this item?</p>

      <div className="search-box-wrapper post-ad-box">
        {/* <FiSearch className="search-icon-inside" /> */}
        <div ref={autocompleteHost} className="place-host-container" />
      </div>

      {/* This button will appear once selectedDisplay is set by handleSelect */}
      {selectedDisplay && (
        <div className="location-confirmation-box animate-in">
          <div className="confirm-row">
            <FiMapPin className="pin" />
            <span>{selectedDisplay}</span>
          </div>
          <button className="magic-action-btn" onClick={() => setStep(5)}>
            Review & Post Ad <FiArrowRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default LocationPicker;